import { Modal, type ModalProps, withModalConditionalRender } from '@billy/design-system'
import type { ReactElement } from 'react'

import { AutomaticPaymentRemindersModalFormContextProvider } from '../../../../contexts/automaticPaymentRemindersModalFormContext'
import type { AutomaticPaymentRemindersType } from '../../../../enums/automaticPaymentRemindersType'
import type { PaymentRemindersDetails } from '../../../../types/paymentReminders/paymentRemindersDetails'
import { AutomaticPaymentRemindersModalContent } from './elements/AutomaticPaymentRemindersModalContent'

interface AutomaticPaymentRemindersModalProps extends ModalProps {
  defaultValues: PaymentRemindersDetails
  onSubmit: (paymentRemindersDetails: PaymentRemindersDetails) => void
  variant: AutomaticPaymentRemindersType
}

const AutomaticPaymentRemindersModalComponent = ({
  defaultValues,
  onSubmit,
  variant,
  ...modalProps
}: AutomaticPaymentRemindersModalProps): ReactElement => (
  <Modal {...modalProps} size="s">
    <AutomaticPaymentRemindersModalFormContextProvider
      defaultValues={defaultValues}
      onSubmit={onSubmit}
      variant={variant}
    >
      <AutomaticPaymentRemindersModalContent modalId={modalProps.id} />
    </AutomaticPaymentRemindersModalFormContextProvider>
  </Modal>
)

export const AutomaticPaymentRemindersModal = withModalConditionalRender(AutomaticPaymentRemindersModalComponent)
